<template>
  <div>
    <el-card class="box-search-card" shadow="nerver">
      <div>
        <div class="booking-filter-area">
          <div style="display: flex; justify-content: space-between">
            <select-operator @changeOperator="changeOperator"></select-operator>
            <div class="booking-search">
              <el-input
                size="mini"
                :clearable="true"
                prefix-icon="el-icon-search"
                v-model="query"
                placeholder="搜索信息"
              ></el-input>
              <el-button
                @click="searchBooking"
                size="mini"
                type="primary"
                icon="el-icon-search"
                plain
                >查询订单</el-button
              >
            </div>
          </div>
        </div>

        <div class="booking-filter-area">
          下单日期：
          <el-date-picker
            class="content-input"
            size="mini"
            v-model="dateSelectorRange"
            type="daterange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            :default-time="['00:00:00', '23:59:59']"
          ></el-date-picker>
        </div>
        <div class="booking-filter-area">
          活动日期：
          <el-date-picker
            class="content-input"
            size="mini"
            v-model="dateSelector"
            type="date"
            start-placeholder="开始月份"
            end-placeholder="结束月份"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </div>
        <div class="booking-filter-area">
          订单编号：
          <el-input
            style="width: 220px"
            size="mini"
            clearable
            v-model="inputBookingNum"
            placeholder="请输入订单编号"
          ></el-input>
        </div>
        <div class="booking-filter-area">
          平台编号：
          <el-input
            style="width: 220px"
            size="mini"
            clearable
            v-model="inputOtaNum"
            placeholder="请输入平台编号"
          ></el-input>
        </div>
      </div>
    </el-card>
    <div v-loading="loading">
      <el-card shadow="nerver">
        <el-table :data="traineeList" style="width: 100%">
          <el-table-column prop="booking_id" label="订单号" width="80">
          </el-table-column>
          <el-table-column prop="course_name" label="课程名称" width="280">
          </el-table-column>
          <!-- 通过slot 让内容剧中 -->
          <el-table-column prop="booking_num" label="" width="80">
            <template slot="header">
              <div style="text-align: center">数量</div>
            </template>
            <template slot-scope="scope">
              <div style="text-align: center">{{ scope.row.booking_num }}</div>
            </template>
          </el-table-column>
          <!-- 服务商信息 -->
          <el-table-column prop="operator" label="服务商" width="200">
            <template slot-scope="scope">
              <div class="el-link-go-to-spu">
                <div style="margin-right: 10px">
                  <span>{{ scope.row.operator }}</span>
                </div>
                <!-- <div>{{ scope.row.operator_id == null }}</div>
            <div>{{ scope.row.spu_id !== null }}</div> -->
                <!-- operator_id:false  spu_id:true -->
                <div
                  v-show="
                    scope.row.operator_id == null && scope.row.spu_id !== null
                  "
                >
                  <el-link
                    @click="goToSpuInfor(scope.row.spu_id)"
                    type="primary"
                    :underline="false"
                    >去添加</el-link
                  >
                </div>
              </div>
            </template>
          </el-table-column>
          <!-- 参加日期 -->
          <el-table-column prop="trip_date" label="参加日期"> </el-table-column>
          <!-- 参加人 -->
          <el-table-column type="expand" label="参加人" width="200">
            <template slot-scope="scope">
              <div
                class="trainee-item-style"
                v-show="scope.row.traveller.length != 0"
              >
                <div v-for="(item, index) in scope.row.traveller" :key="index">
                  <div>
                    <div style="display: inline-block; margin-right: 20px">
                      姓名： {{ item.trainee_name }}
                    </div>
                    <div style="float: right; margin-left: 10px">
                      <div v-if="item.is_certificate">
                        <i class="el-icon-success">已认证</i>
                        <i
                          @click="deleteCourseLog(item.log_id)"
                          style="display: inline-black; margin-left: 10px"
                          class="el-icon-delete"
                        ></i>
                      </div>
                      <div v-else><i class="el-icon-error">未认证</i></div>
                    </div>

                    <div style="display: inline-block; font-size: 10px">
                      id：{{ item.trainee_id }}
                    </div>
                    <!-- 修改绑定人 -->

                    <link-button
                      style="display: inline-block"
                      @clickLinkButton="changeTraveller(scope.row.booking_id)"
                      :underline="false"
                      buttonName="修改出行人"
                      type="primary"
                    ></link-button>

                    <!-- 是否是会员 -->
                    <!-- <div
                    style="
                      display: inline-block;
                      float: center;
                      font-size: 0.1rem;
                    "
                  >
                    非会员｜
                    <el-link :underline="false" size="mini">绑定会员</el-link>
                  </div> -->
                    <!-- 操作 -->
                    <div
                      style="
                        display: inline-block;
                        float: right;
                        font-size: 0.1rem;
                      "
                    >
                      <el-link
                        type="primary"
                        @click="checkCertificate(scope.row, item)"
                        :underline="false"
                        size="mini"
                        >证书</el-link
                      >
                    </div>
                  </div>
                </div>
              </div>
              <!-- style="display: inline" style="display: flex; justify-content: space-around"-->
              <div
                class="trainee-item-style"
                v-show="scope.row.traveller.length == 0"
              >
                <div style="display: inline">
                  <i class="el-icon-error"> 订单没有绑定出行人</i>
                </div>
                <el-link
                  style="float: right"
                  type="primary"
                  @click="selectTraveller(scope.row.booking_id)"
                  :underline="false"
                  size="mini"
                  >绑定出行人</el-link
                >
              </div>
            </template>
          </el-table-column>
          <!-- 未添加出行人 -->
          <el-table-column label="" width="30">
            <template slot-scope="scope">
              <div v-show="scope.row.traveller.length == 0">
                <i class="el-icon-error"></i>
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column label="查看">
        <template slot-scope="scope">
          <el-button
            
            type="text"
            size="small"
          >
            查看证书
          </el-button>
        </template>
      </el-table-column> -->
        </el-table>
        <!-- ----------------- 分页 ------------------ -->
        <div class="pagination">
          <el-pagination
            @current-change="handleCurrentChange_system"
            :small="true"
            background
            layout="prev, pager, next,total"
            :current-page.sync="pagenum_system"
            :page-size="pagesize"
            :total="page_account"
          ></el-pagination>
        </div>
        <!-- 绑定出行人 -->
        <select-add-traveller
          ref="select_add_traveller"
          :traveller_data="traveller_data"
          :showSelectTraveller.sync="showSelectTraveller"
          @finishBand="finishBand"
          @onClose="onCloseSelectTraveller"
        ></select-add-traveller>
        <!-- 绑定出行人结束 -->
      </el-card>
    </div>
  </div>
</template>

<script>
import { tpx_app } from "../../network/request";
import SelectAddTraveller from "../../components/booking/SelectAddTraveller";
import SelectOperator from "../../components/common/select/SelectOperator";
import LinkButton from "../../components/common/button/LinkButton";
export default {
  name: "trainee-list",
  components: {
    "select-add-traveller": SelectAddTraveller,
    "select-operator": SelectOperator,
    LinkButton,
  },
  data() {
    return {
      // 表格样式
      // 查询条件
      op_id: "", //服务商id
      dateSelectorRange: [], // 下单日期
      dateSelector: "", // 活动日期
      inputBookingNum: "", // 系统单号
      inputOtaNum: "", // 搜索的平台单号
      inputBookingNum: "", // 系统单号
      query: "", // 查询
      //
      loading: true,
      traineeList: [],
      traveller_data: [],
      showSelectTraveller: false,
      // 分页
      pagenum_system: 1, //当前页
      pagesize: 10,
      page_account: 0,
    };
  },
  mounted() {
    let option = {};
    let val = this.pagenum_system;
    this.getTraineeList(val, option);
  },
  watch: {
    traineeList: {
      handler(newValue) {
        this.traineeList = newValue;
      },
    },
  },
  methods: {
    // 删除 一条记录
    deleteCourseLog(value) {
      this.$confirm("此操作将永久删除该课程记录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 执行删除
          this.$http.get(`/delete_course_log?log_id=${value}`).then((res) => {
            console.log(res);
            if (res.data.errno == "0") {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            } else {
              this.$message({
                type: "warning",
                message: res.data.errmsg,
              });
            }
          });
        })
        .catch(() => {
          // 取消删除
        });
    },
    // 查询条件：服务商
    changeOperator(value) {
      this.op_id = value;
    },
    finishBand() {
      this.getTraineeList();
    },
    // 默认获取列表
    getTraineeList(val, option = {}) {
      let current_page = val ? val : this.pagenum_system;
      tpx_app({
        url: "/get_trainee_list",
        method: "get",
        params: {
          op_id: option.op_id || "",
          std: option.std || "",
          etd: option.etd || "",
          booking_id: option.booking_id || "",
          ota_id: option.ota_id || "",
          is_delete: option.is_delete || "",
          page_number: current_page,
          page_size: this.pagesize,
        },
      }).then((res) => {
        this.page_account = res.data.count;
        this.traineeList = res.data.booking;
        this.loading = false;
      });
    },
    // 搜索订单按钮 搜索条件的查询按钮 ,根据条件查询
    searchBooking(val) {
      // 拼接 链接，发送请求，更新数据

      if (this.dateSelectorRange == 0 || this.dateSelectorRange == null) {
        this.dateSelectorRange = [];
      }
      if (this.dateSelector == 0 || this.dateSelector == null) {
        this.dateSelector = "";
      }

      let sd = this.dateSelectorRange[0];
      if (sd == undefined) {
        sd = "";
      }
      let ed = this.dateSelectorRange[1];
      if (ed == undefined) {
        ed = "";
      }
      let td = this.dateSelector;
      let current_page = val ? val : this.pagenum_system;

      let option = {
        op_id: 1,
        std: sd,
        etd: ed,
        booking_id: this.inputBookingNum,
        ota_id: this.inputOtaNum,
        page_number: current_page,
        page_siaze: this.pagesize,
      };
      // console.log(option);
      this.getTraineeList(current_page, option);
    },
    checkCertificate(value, item) {
      this.$router.push({
        name: "show_certificate",
        params: {
          booking_info: value,
          item: item,
        },
      });
    },
    // 绑定出行人
    selectTraveller(value) {
      this.$refs.select_add_traveller.booking_no = value;
      this.$http
        .get(`/booking/get_all_travellers?booking_id=${value}`)
        .then((res) => {
          const { data, errno, errmsg, spu_id } = res.data;
          if (errno == "0") {
            this.loading = true;
            this.traveller_data = data;
            this.showSelectTraveller = !this.showSelectTraveller;
            this.getTraineeList();
            // console.log(this.traineeList);
          } else if (errno == "4701") {
            this.$notify.error({
              title: "错误",
              dangerouslyUseHTMLString: true,
              message: `<strong>${errmsg} :<a style="color:#ff5421" href="/product-intro?spu_id=${spu_id}" target="_blank">点击前往绑定</a></strong>`,
            });
          } else {
            this.$notify.error({
              title: "错误",
              message: errmsg,
            });
          }
        });
    },
    // 修改出行人
    changeTraveller(value) {
      // console.log("value");
      this.$refs.select_add_traveller.booking_no = value;
      this.$http
        .get(`/booking/get_all_travellers?booking_id=${value}`)
        .then((res) => {
          const { data, errno, errmsg, spu_id } = res.data;
          if (errno == "0") {
            this.loading = true;
            this.traveller_data = data;
            this.showSelectTraveller = !this.showSelectTraveller;
            // console.log(this.traineeList);
          } else if (errno == "4701") {
            this.$notify.error({
              title: "错误",
              dangerouslyUseHTMLString: true,
              message: `<strong>${errmsg} :<a style="color:#ff5421" href="/product-intro?spu_id=${spu_id}" target="_blank">点击前往绑定</a></strong>`,
            });
          } else {
            this.$notify.error({
              title: "错误",
              message: errmsg,
            });
          }
        });
    },
    onCloseSelectTraveller() {
      this.loading = false;
    },
    handleCurrentChange_system(val) {
      this.loading = true;
      this.pagenum_system = val;
      this.getTraineeList(val);
    },
    // 打开spu页面
    goToSpuInfor(value) {
      // console.log(value);
      let routeData = this.$router.resolve({
        path: `/product-intro`,
        query: {
          spu_id: value,
        },
      });
      window.open(routeData.href, "_blank");
    },
  },
};
</script>

<style >
.box-search-card {
  height: auto;
  margin-bottom: 5px;
}
.trainee-item-style {
  padding: 3px 10px;
  margin: 5px;
}
.trainee-item-style:hover {
  background-color: rgb(236, 236, 236);
  cursor: pointer;
}
.pagination {
  margin-top: 20px;
  margin-bottom: 20px;
  text-align: right;
}
.el-link-go-to-spu {
  display: flex;
  align-items: center;
}
.booking-search {
  display: flex;
  float: right;
}
.booking-filter-area {
  margin-bottom: 10px;
}
.booking-search button {
  margin-left: 10px;
}
.el-table__body .el-table__expanded-cell {
  background-color: blanchedalmond;
  padding: 0;
}
</style>